import LoggerService,{formatTrace,formatInfo} from '../../LoggerService';
import {
  _checkTokens,
  _checkErrors,
  _tryOrRefresh,
  I_COMMON_GET_ALL_PARAMS,
  I_COMMON_GET_ITEM_PARAMS,
  I_COMMON_DELETE_PARAMS,
  I_COMMON_IMPORT_PARAMS,
  I_COMMON_CREATE_PARAMS,
  I_COMMON_PUT_PARAMS,
} from './_base';

import I_CHARGES, {I_CHARGE, I_CHARGE_ACTIVITY, I_IMPORT_CHARGES_OK} from '../interfaces/I_CHARGES';
import {
  getChargesResponse,
  postChargeResponse,
  deleteChargeResponse,
  getChargeResponse,
  putChargeResponse,
  importChargesResponse,
  exportChargesResponse,
} from '../ApiEndpoints';

// ---------------------------------
// --- CHARGES
// ---------------------------------

const logger = LoggerService.getInstance();

interface I_GET_PARAMS extends I_COMMON_GET_ALL_PARAMS {
  from_date: string;
  to_date: string;
  activity_types: string;
  directions_ops: string;  // direction de la charge
  hubs_ops: string;  // pole de direction de la charge
  directions_hr: string;  // direction de l'activité de la charge
  hubs_hr: string;  // pole de direction de l'activité de la charge

  collaborators: string;
  skills: string;
  functions: string;
  billing_customers: string;
  audited_customers: string;
  referentials: string;
  referential_types: string;
  of_number: string;
}
interface I_EXPORT_PARAMS extends I_GET_PARAMS {
  file_type: string;  // csv ou  xls
  file_format: string;
}
interface I_CHARGE_FIELDS {
  /** id du model si la charge a été créée à partir d'un model de charge, undefined/null sinon */
  id_model?: number;
  //** nom de la charge */
  name: string;
  /** id du client / organisme */
  audited_customer_id: number;
  /** id du referentiel client (agrement d'organisme) */
  referential_customer_id: number;
  /** date de debut */
  from_date: string;
  /** date de fin */
  to_date: string;
  /** direction OPS de la charge */
  direction: string;
  /** pole de direction OPS de la charge */
  hub: string;
  /** volume horaire de la charge */
  hourly_volume: number;
  /** description de la charge (opt.) */
  description?: string;
  /** id du type d'activité de la charge (opt.) */
  activity_type_id?: number;
  /** id du donneur d'ordre (opt.) */
  billing_customer_id?: number;
  /** Numero d'OF (liaison charge - facturation) (opt.) */
  of_number?: string;
  /** numero du ticket JIRA associé */
  nb_tickets_jira?: number;
  /** liste des activités du modele de charge (peut etre vide) */
  activities: I_CHARGE_ACTIVITY[];
}
interface I_CREATE_CHARGE_PARAMS extends I_COMMON_CREATE_PARAMS, I_CHARGE_FIELDS {}
interface I_PUT_CHARGE_PARAMS extends I_COMMON_PUT_PARAMS, I_CHARGE_FIELDS {}


// ----

const isMissingField = (item:I_CHARGE_FIELDS) => {
  const nameKO = !item.name || item.name === null || item.name.trim() === '';
  const auditedCustomerKO = item.audited_customer_id === undefined || item.audited_customer_id === null;
  const referentialclientKO = item.referential_customer_id === undefined || item.referential_customer_id === null;
  const fromdateKO = !item.from_date || item.from_date === null || item.from_date.trim() === '';
  const todateKO = !item.to_date || item.to_date === null || item.to_date.trim() === '';
  const hourlyvolumeKO = item.hourly_volume === undefined || item.hourly_volume === null || item.hourly_volume <= 0;
  const directionKO = !item.direction || item.direction === null || item.direction.trim() === '';
  const hubKO =  false /*!item.hub || item.hub === null || item.hub.trim() === ''*/;  // depend de si direction a des poles, on a pas l'info ici
  const descriptionKO = false;
  const activitytypeKO = false;
  const billingcustomerKO = false;
  const ofnumberKO = false;
  const nbticketjira = false;

  const chargeKO = nameKO || auditedCustomerKO || referentialclientKO || descriptionKO || activitytypeKO || fromdateKO || todateKO ||
    hourlyvolumeKO || directionKO || hubKO || billingcustomerKO || ofnumberKO || nbticketjira;

  let activitiesKO = false;
  item.activities.forEach((activity:I_CHARGE_ACTIVITY) => {
    const anameKO = !activity.name || activity.name === null || activity.name.trim() === '';
    const afromdateKO = !activity.from_date || activity.from_date === null || activity.from_date.trim() === '';
    const atodateKO = !activity.to_date || activity.to_date === null || activity.to_date.trim() === '';
    const avolumeKO = activity.value_volume === undefined || activity.value_volume === null || activity.value_volume <= 0;
    if (anameKO || afromdateKO || atodateKO || avolumeKO) {
      activitiesKO = true;
    }
    if (activitiesKO) {
      logger.debug('Missing fields for activity :',{anameKO,afromdateKO,atodateKO,avolumeKO})
    }
  });

  if (chargeKO) {
    logger.debug('Missing fields for charge :',{nameKO,referentialclientKO,fromdateKO,todateKO,hourlyvolumeKO,directionKO,hubKO})
  }

  return chargeKO || activitiesKO;
}

// ----





/**
 * Récupère la liste des charges
 * @param obj
 * @returns
 */
const getList = async ({
  accessToken,refreshToken,dispatch,state,
  page,
  from_date,to_date,activity_types,
  directions_ops,hubs_ops,directions_hr,hubs_hr,
  collaborators,skills,functions,billing_customers,of_number,
  audited_customers,
  referentials,
  referential_types,
}:I_GET_PARAMS):Promise<I_CHARGES> => {
  logger.debug('ApiServices - getCharges - ',{page});
  // pre-verification qu'on a bien des token, sinon sert a rien de faire la requete
  await _checkTokens(accessToken,refreshToken);
  // requete le endpoint
  const response = await _tryOrRefresh({
    request: (usedAccessToken:string) => {
      return getChargesResponse({
        accessToken:usedAccessToken,page,
        from_date,to_date,activity_types,directions_ops,hubs_ops,directions_hr,hubs_hr,collaborators,
        skills,functions,billing_customers,
        audited_customers,
        referentials,
        referential_types,
        of_number,
      });
    },
    accessToken: accessToken || '', // normalement c'est non vide car on a fait un checkTokens
    refreshToken: refreshToken || '', // normalement c'est non vide car on a fait un checkTokens
    dispatch,state
  });
  logger.trace(...formatTrace('ApiServices - getCharges - returned response',response));
  // verifie que la reponse est ok, sinon throw error
  await _checkErrors(response);
  // extrait les données
  const body:I_CHARGES = await response.json();
  logger.debug('ApiServices - getCharges - ok, returned body',body);
  return body;
};

/**
 * Crée une charge
 * @param param0
 * @returns
 */
const create = async (args:I_CREATE_CHARGE_PARAMS):Promise<string> => {
  logger.debug('ApiServices - createCharge - ...');
  const {
    accessToken,refreshToken,
    dispatch,state,
    name,description,of_number,hourly_volume,
    direction,hub,
    from_date,to_date,
    audited_customer_id,
    referential_customer_id,
    billing_customer_id,
    activity_type_id,
    nb_tickets_jira,
    id_model,
    activities,
  } = args;
  // pre-verification qu'on a bien des token, sinon sert a rien de faire la requete
  await _checkTokens(accessToken,refreshToken);
  // pre-verification qu'on a bien des valeurs obligatoires, sinon sert a rien de faire la requete
  if (isMissingField(args)) {
    const error = {
      error: true,
      errorCode: 1000,
      errorText: 'Missing field(s)',
      errorMessage: 'Missing field(s) to post new charge',
    };
    return Promise.reject(error);
  }
  // requete le endpoint
  const response = await _tryOrRefresh({
    request: (usedAccessToken:string) => {
      return postChargeResponse({
        accessToken:usedAccessToken,
        id_model,
        name,description,activity_type_id,
        of_number,hourly_volume,from_date,to_date,direction,hub,billing_customer_id,
        audited_customer_id,
        referential_customer_id,
        nb_tickets_jira,activities,
      });
    },
    accessToken,
    refreshToken,
    dispatch,state
  });
  logger.trace(...formatTrace('ApiServices - createCharge - returned response',response));
  // verifie que la reponse est ok, sinon throw error
  await _checkErrors(response);
  // extrait les données
  const body:string = await response.text();
  logger.debug('ApiServices - createCharge - ok, returned body',body);
  logger.info(...formatInfo('Charge created!'));
  return body;
};

/**
 * Supprime une charge
 * @param param0
 * @returns
 */
const remove = async ({accessToken,refreshToken,id,dispatch,state}:I_COMMON_DELETE_PARAMS):Promise<string> => {
  logger.debug('ApiServices - deleteCharge - ...');
  // pre-verification qu'on a bien des token, sinon sert a rien de faire la requete
  await _checkTokens(accessToken,refreshToken);
  // requete le endpoint
  const response = await _tryOrRefresh({
    request: (usedAccessToken:string) => {
      return deleteChargeResponse({accessToken:usedAccessToken,id});
    },
    accessToken: accessToken || '', // normalement c'est non vide car on a fait un checkTokens
    refreshToken: refreshToken || '', // normalement c'est non vide car on a fait un checkTokens
    dispatch,state
  });
  logger.trace(...formatTrace('ApiServices - deleteCharge - returned response',response));
  // verifie que la reponse est ok, sinon throw error
  await _checkErrors(response);
  // extrait les données
  const body:string = await response.text();
  logger.debug('ApiServices - deleteCharge - ok, returned body',body);
  logger.info(...formatInfo('Charge deleted!'));
  return body;
};


/**
 * Modifie une charge
 * @param param0
 * @returns
 */
const update = async (args:I_PUT_CHARGE_PARAMS):Promise<string> => {
  logger.debug('ApiServices - updateCharge - ...');
  const {
    accessToken,refreshToken,
    dispatch,state,
    id,
    name,description,of_number,hourly_volume,
    direction,hub,
    from_date,to_date,
    audited_customer_id,
    referential_customer_id,
    billing_customer_id,
    activity_type_id,
    nb_tickets_jira,
    id_model,
    activities,
  } = args;
  // pre-verification qu'on a bien des token, sinon sert a rien de faire la requete
  await _checkTokens(accessToken,refreshToken);
  // pre-verification qu'on a bien des valeurs obligatoires, sinon sert a rien de faire la requete
  if (isMissingField(args)) {
    const error = {
      error: true,
      errorCode: 1000,
      errorText: 'Missing field(s)',
      errorMessage: 'Missing field(s) to update charge',
    };
    return Promise.reject(error);
  }
  // requete le endpoint
  const response = await _tryOrRefresh({
    request: (usedAccessToken:string) => {
      return putChargeResponse({
        accessToken:usedAccessToken,id,
        id_model,
        name,description,activity_type_id,
        of_number,hourly_volume,from_date,to_date,direction,hub,billing_customer_id,
        audited_customer_id,
        referential_customer_id,
        nb_tickets_jira,activities,
      });
    },
    accessToken: accessToken || '', // normalement c'est non vide car on a fait un checkTokens
    refreshToken: refreshToken || '', // normalement c'est non vide car on a fait un checkTokens
    dispatch,state
  });
  logger.trace(...formatTrace('ApiServices - updateCharge - returned response',response));
  // verifie que la reponse est ok, sinon throw error
  await _checkErrors(response);
  // extrait les données
  const body:string = await response.text();
  logger.debug('ApiServices - updateCharge - ok, returned body',body);
  logger.info(...formatInfo('Charge updated!'));
  return body;
};

/**
 * Récupère la charge
 * @param param0
 * @returns
 */
const getItem = async ({accessToken,refreshToken,id,dispatch,state}:I_COMMON_GET_ITEM_PARAMS) => {
  logger.debug('ApiServices - getCharge - ...');
  // pre-verification qu'on a bien des token, sinon sert a rien de faire la requete
  await _checkTokens(accessToken,refreshToken);
  // requete le endpoint
  const response = await _tryOrRefresh({
    request: (usedAccessToken:string) => {
      return getChargeResponse({accessToken:usedAccessToken,id});
    },
    accessToken: accessToken || '', // normalement c'est non vide car on a fait un checkTokens
    refreshToken: refreshToken || '', // normalement c'est non vide car on a fait un checkTokens
    dispatch,state
  });
  logger.trace(...formatTrace('ApiServices - getCharge - returned response',response));
  // verifie que la reponse est ok, sinon throw error
  await _checkErrors(response);
  // extrait les données
  const body:I_CHARGE = await response.json();
  logger.debug('ApiServices - getCharge - ok, returned body',body);
  return body;
};

/**
 * Import du plan de charge
 * @param param0
 * @returns
 */
const importList = async ({
                            accessToken,refreshToken,file, dispatch,state
                          }:I_COMMON_IMPORT_PARAMS):Promise<I_IMPORT_CHARGES_OK> => {
  logger.debug('ApiServices - importCharges - ...');
  // pre-verification qu'on a bien des token, sinon sert a rien de faire la requete
  await _checkTokens(accessToken,refreshToken);
  // pre-verification qu'on a bien des valeurs obligatoires, sinon sert a rien de faire la requete
  if (!file) {
    const error = {
      error: true,
      errorCode: 1000,
      errorText: 'Missing file',
      errorMessage: 'Missing file to post charges',
    };
    return Promise.reject(error);
  }
  // requete le endpoint
  const response = await _tryOrRefresh({
    request: (usedAccessToken:string) => {
      return importChargesResponse({
        accessToken:usedAccessToken,file,
      });
    },
    accessToken: accessToken || '', // normalement c'est non vide car on a fait un checkTokens
    refreshToken: refreshToken || '', // normalement c'est non vide car on a fait un checkTokens
    dispatch,state
  });
  logger.trace(...formatTrace('ApiServices - importCharges - returned response',response));
  // verifie que la reponse est ok, sinon throw error
  await _checkErrors(response);
  // extrait les données
  const body:I_IMPORT_CHARGES_OK = await response.json();
  logger.debug('ApiServices - importCharges - ok, returned body',body);
  logger.info(...formatInfo('Charges imported!'));
  return body;
};


/**
 * Exporte la liste des charges
 * @param obj
 * @returns
 */
const exportList = async ({
  accessToken,refreshToken,dispatch,state,
  from_date,to_date,activity_types,
  directions_ops,hubs_ops,directions_hr,hubs_hr,
  collaborators,skills,functions,billing_customers,of_number,
  audited_customers,
  referentials,
  referential_types,
  file_type,
  file_format,
}:I_EXPORT_PARAMS):Promise<string|Blob> => {
  logger.debug('ApiServices - exportCharges - ');
  // pre-verification qu'on a bien des token, sinon sert a rien de faire la requete
  await _checkTokens(accessToken,refreshToken);
  // requete le endpoint
  const response = await _tryOrRefresh({
    request: (usedAccessToken:string) => {
      return exportChargesResponse({
        accessToken:usedAccessToken,
        from_date,to_date,activity_types,directions_ops,hubs_ops,directions_hr,hubs_hr,collaborators,
        skills,functions,billing_customers,
        audited_customers,
        referentials,
        referential_types,
        of_number,
        file_type,
        file_format,
      });
    },
    accessToken: accessToken || '', // normalement c'est non vide car on a fait un checkTokens
    refreshToken: refreshToken || '', // normalement c'est non vide car on a fait un checkTokens
    dispatch,state
  });
  logger.trace(...formatTrace('ApiServices - exportCharges - returned response',response));
  // verifie que la reponse est ok, sinon throw error
  await _checkErrors(response);
  // extrait les données !!!! CSV ou xlsx
  logger.trace(...formatTrace('ApiServices - exportCharges - file_type=',file_type));
  if (file_type === 'xlsx') {
    const body:Blob = await response.blob();
    logger.debug('ApiServices - exportCharges - ok, returned body',body);
    return body;
  }
  const body:string = await response.text();
  logger.debug('ApiServices - exportCharges - ok, returned body',body);
  return body;
};

const chargesServices = {
  getList,
  create,
  remove,
  update,
  getItem,
  importList,
  exportList,
};

export default chargesServices;
